import React from 'react';
import './block_error.component.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons';

const ErrorBlock = (props) => {
  return (
    <section className={`error-block ${props.className ?? ''}`}>
      <FontAwesomeIcon icon={faExclamationCircle} />
      <div>
        {props.title || props.info ? (
          <>
            <h4 className="title">{props.title}</h4>
            {props.info && <p className="info">{props.info}</p>}
          </>
        ) : (
          <h4 className="title mb-0">
            {props.text ? props.text : 'Something went wrong'}
          </h4>
        )}
      </div>
    </section>
  );
};

export default ErrorBlock;
